// extracted by mini-css-extract-plugin
export default {"block-mover":"BlockMover_block-mover__gtxEZ","block-mover__button":"BlockMover_block-mover__button__iny9a"};